<template>
    <div>
        <form-wrapper @form-submit="submit">
            <form-row>
                <form-cell width="half">
                    <datepicker-input
                        ref="dateFrom"
                        :formData="data"
                        :label="$t('forms.reservations.reservation_filter.fields.date_from.label')"
                        valuePath="dateFrom"
                        :placeholder="$t('forms.reservations.reservation_filter.fields.date_from.placeholder')"
                        :lowerLimit="new Date()"
                        :isSubmittable="false"
                        :upperLimit="upperLimit"
                        @date-changed="dateFromChanged"
                    ></datepicker-input>
                </form-cell>
                <form-cell width="half">
                    <datepicker-input
                        ref="dateTo"
                        :formData="data"
                        :label="$t('forms.reservations.reservation_filter.fields.date_to.label')"
                        :placeholder="$t('forms.reservations.reservation_filter.fields.date_to.placeholder')"
                        valuePath="dateTo"
                        :isSubmittable="false"
                        :lowerLimit="lowerLimit"
                        @date-changed="dateToChanged"
                    ></datepicker-input>
                </form-cell>
            </form-row>
            <form-row v-if="availabilityOptions">
                <form-cell width="full">
                    <multi-select-input
                        :formData="data"
                        valuePath="availabilityIds"
                        :label="$t('modals.add_inactivity_modal.multi_select_input.label_input')"
                        :placeholder="$t('modals.add_inactivity_modal.multi_select_input.placeholder_input')"
                        :options="availabilityOptions"
                        :showSelectAllOption="true"
                        @change="change"
                    ></multi-select-input>
                </form-cell>
            </form-row>

            <form-row v-else>
                <form-cell width="full">
                    <br />
                    <checkbox-input
                        :formData="data"
                        :value="data.allAvailabilityIds"
                        :label="$t('modals.add_inactivity_modal.checkbox_label')"
                        valuePath="allAvailabilityIds"
                        @change="change"
                    ></checkbox-input>
                </form-cell>
            </form-row>
            <template #footer>
                <common-buttons>
                    <common-button
                        type="primary"
                        :isSubmittable="false"
                        :isProcessing="isLoading"
                        :label="$t('forms.user.profile.buttons.save')"
                        @click="saveInactivity()"
                    ></common-button>
                </common-buttons>
            </template>
        </form-wrapper>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import { dateFormat } from '~/helpers'

    export default {
        mixins: [FormMixin],

        props: {
            availability: { type: Array, required: true },
        },

        data() {
            return {
                upperLimit: null,
                lowerLimit: new Date(),
                availabilityOptions: [],
                userAvailability: [],
            }
        },

        methods: {
            setAvailabilityOptions() {
                this.userAvailability = this.availability.filter((item) => {
                    const isUserPerformerOrModerator = item.availabilityUsers
                        .map((au) => au.user.id)
                        .includes(this.$auth.getUser().id)
                    return isUserPerformerOrModerator
                })

                this.availabilityOptions = this.userAvailability?.map((compAva) => ({
                    label: compAva.titleTextContent.originalText,
                    value: compAva.id,
                }))
            },

            dateFromChanged(value) {
                if (value !== undefined) {
                    this.lowerLimit = dateFormat(value)
                    this.setValue('dateFrom', value)
                } else {
                    this.lowerLimit = new Date()
                    delete this.data['dateFrom']
                }
            },
            dateToChanged(value) {
                if (value !== undefined) {
                    this.upperLimit = dateFormat(value)
                    this.setValue('dateTo', value)
                } else {
                    this.upperLimit = null
                    delete this.data['dateTo']
                }
            },
            isChecked({ value }) {
                if (!this.value) {
                    return false
                }
                if (this.valuePath) {
                    return this.formData[this.valuePath]?.includes(value)
                }

                return this.value.includes(value)
            },
            saveInactivity() {
                this.emitEvent({ name: 'out-if-avilability', payload: this.data })
            },
        },

        mounted() {
            this.setAvailabilityOptions()
        },
    }
</script>
